import {object, string} from 'yup';

export const adminGroupTypeValidator = object().shape({
  name: string().required('Fill in your group type name'),
});
